import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
    Box,
    Chip,
    Container,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { BlogHeader } from './blog/BlogLayout';
import { blogPosts } from './blog/blogPosts';
import SiteFooter, { FooterCta } from '../components/landing/SiteFooter';

const CANONICAL_URL = 'https://finradar.brpadvice.ru/blog/';

function BlogIndexPage() {
    const handleRegisterClick = () => {
        window.location.href = '/vhod/';
    };

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
            <Helmet defer={false}>
                <title>Блог ФинРадара: анализ выписок, операций и контрагентов</title>
                <meta
                    name="description"
                    content="Практические материалы ФинРадара об анализе банковских выписок, подозрительных операциях, контрагентах и финансовых рисках."
                />
                <link rel="canonical" href={CANONICAL_URL} />
            </Helmet>

            <BlogHeader />

            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
                <Stack spacing={{ xs: 4, md: 6 }}>
                    <Box sx={{ maxWidth: 820 }}>
                        <Typography variant="overline" sx={{ color: '#155EEF', fontWeight: 800, letterSpacing: 0 }}>
                            Блог ФинРадара
                        </Typography>
                        <Typography
                            component="h1"
                            sx={{
                                mt: 1,
                                color: '#101828',
                                fontSize: { xs: 36, md: 56 },
                                fontWeight: 900,
                                lineHeight: 1.05,
                            }}
                        >
                            Разбор банковских выписок, операций и контрагентов
                        </Typography>
                        <Typography sx={{ mt: 2, color: '#475467', fontSize: { xs: 18, md: 20 }, lineHeight: 1.7 }}>
                            Прикладные статьи для арбитражных управляющих, юристов и финансовых специалистов, которым нужно быстрее находить риски в больших массивах операций.
                        </Typography>
                    </Box>

                    <Stack spacing={2.5}>
                        {blogPosts.map((post) => (
                            <Paper
                                key={post.slug}
                                component={RouterLink}
                                to={`/blog/${post.slug}/`}
                                elevation={0}
                                sx={{
                                    display: 'block',
                                    p: { xs: 3, md: 4 },
                                    border: '1px solid #EAECF0',
                                    borderRadius: 2,
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    backgroundColor: '#FFFFFF',
                                    transition: 'border-color 160ms ease, transform 160ms ease',
                                    '&:hover': {
                                        borderColor: '#84ADFF',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <Stack spacing={2}>
                                    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                                        <Chip size="small" label={post.category} sx={{ fontWeight: 800, backgroundColor: '#EFF4FF', color: '#155EEF' }} />
                                        <Chip
                                            size="small"
                                            icon={<AccessTimeRoundedIcon />}
                                            label={post.readingTime}
                                            sx={{
                                                fontWeight: 700,
                                                backgroundColor: '#F2F4F7',
                                                color: '#475467',
                                                '& .MuiChip-icon': { color: '#667085' },
                                            }}
                                        />
                                        <Chip size="small" label={post.datePublishedLabel} sx={{ fontWeight: 700, backgroundColor: '#F2F4F7', color: '#475467' }} />
                                    </Stack>
                                    <Typography component="h2" sx={{ color: '#101828', fontSize: { xs: 26, md: 34 }, fontWeight: 900, lineHeight: 1.15 }}>
                                        {post.title}
                                    </Typography>
                                    <Typography sx={{ color: '#475467', fontSize: 18, lineHeight: 1.65 }}>
                                        {post.listDescription || post.description}
                                    </Typography>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ color: '#155EEF', fontWeight: 900 }}>
                                        <Typography sx={{ fontWeight: 900 }}>Читать статью</Typography>
                                        <ArrowForwardRoundedIcon fontSize="small" />
                                    </Stack>
                                </Stack>
                            </Paper>
                        ))}
                    </Stack>
                </Stack>
            </Container>

            <FooterCta onRegisterClick={handleRegisterClick} />
            <SiteFooter onRegisterClick={handleRegisterClick} />
        </Box>
    );
}

export default BlogIndexPage;
